export default {
	'delete-unit': 'delete unit ',
	unit: 'unit'
}